/**
 * useTodaySteps
 *
 * Derives the 3-step Today's Card state from existing done-flags.
 * Streak-required steps: Heart Rate → Respiratory Rate → Weight.
 * The Wellness Check panel (fluid, temperature, mucous membranes) is handled
 * separately via TodayToolbar and does not count toward the streak.
 */

export type StepId = 'heartRate' | 'respRate' | 'weight';

export interface TodayStepState {
  id: StepId;
  /** 1-based display index */
  num: number;
  done: boolean;
  /** Whether the step's input form is accessible */
  unlocked: boolean;
}

export interface UseTodayStepsFlags {
  hrDone: boolean;
  rrDone: boolean;
  weightDone: boolean;
}

export function useTodaySteps(flags: UseTodayStepsFlags): {
  steps: TodayStepState[];
  doneCount: number;
  allDone: boolean;
} {
  const { hrDone, rrDone, weightDone } = flags;

  const steps: TodayStepState[] = [
    {
      id: 'heartRate',
      num: 1,
      done: hrDone,
      unlocked: true,
    },
    {
      id: 'respRate',
      num: 2,
      done: rrDone,
      unlocked: true,
    },
    {
      id: 'weight',
      num: 3,
      done: weightDone,
      unlocked: true,
    },
  ];

  const doneCount = steps.filter(s => s.done).length;
  const allDone = doneCount === 3;

  return { steps, doneCount, allDone };
}
